import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function useActivityTracker() {
  const navigate = useNavigate();

  useEffect(() => {
    let inactivityTimeout;
    const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutes in milliseconds
    // const INACTIVITY_LIMIT = 30 * 1000; // 30 seconds in milliseconds

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(() => {
        handleLogoutDueToInactivity();
      }, INACTIVITY_LIMIT);
    };

    const handleLogoutDueToInactivity = async () => {
      try {
        await axios.post(
          "http://localhost:3000/api/auth/logout",
          {},
          { withCredentials: true }
        );
        localStorage.clear();

        alert("You have been logged out due to inactivity.");
        navigate("/login");
      } catch (error) {
        console.error("Error during auto logout:", error);
      }
    };

    const events = ["mousemove", "keydown", "click"];
    events.forEach((event) =>
      window.addEventListener(event, resetInactivityTimer)
    );

    resetInactivityTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetInactivityTimer)
      );
      clearTimeout(inactivityTimeout);
    };
  }, [navigate]);
}

export default useActivityTracker;
